
import {
  ref,
  onMounted,
  defineComponent,
  defineEmits,
  watch,
  computed,
  reactive,
} from 'vue';
import { useStore, } from 'vuex';
import {
  ticketImageIp,
  allTicketTypeList,
  ticketStatus,
  ticketTips,
} from '@/configs/index';
import {
  VerticalAlignTopOutlined,
  VerticalAlignBottomOutlined,
  QuestionCircleFilled,
} from '@ant-design/icons-vue';

import {
  Image,
  Tooltip,
} from 'ant-design-vue';
import { validateSearch, } from 'ant-design-vue/lib/vc-mentions/src/util';
import moment, { Moment, duration, } from 'moment';

const { PreviewGroup, } = Image;

export default defineComponent({
  components: {
    PreviewGroup,
    Image,
    // Tooltip,
  },
  props: {
    ticketDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:particularsVisible',],
  setup (props, context) {
    const store = useStore();

    const timeInterval = ref();
    const fileLists = ref<any[]>([]);
    const textFileLists = ref<any[]>([]);
    const textFileNameLists = ref<any[]>([]);
    const countdown = reactive({
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',

      // 是否显示倒计时
      isFinish: false,
      // 是否显示已逾期
      finishInTime: false,
    });

    // 文字提示框渲染父节点
    const getPopupContainer = () => document.getElementById('defualt');

    const handleTime = (time: number) => {
      if (time || (time === 0)) {
        if (time > 60 && time % 60 !== 0) {
          return `${Math.floor(time / 60)}小时${time % 60}分钟`;
        }
        if (time >= 60 && time % 60 === 0) {
          return `${Math.floor(time / 60)}小时`;
        }

        return `${time}分钟`;
      }
    };
    const openFile = (urlStr: string) => {
      window.open(urlStr);
    };

    // 清空定时器重置计时
    const clearTimeInterval = () => {
      clearInterval(timeInterval.value);
      timeInterval.value = null;
      countdown.days = '00';
      countdown.hours = '00';
      countdown.minutes = '00';
      countdown.seconds = '00';
      countdown.isFinish = false;
      countdown.finishInTime = false;
    };

    const dealLimitTime = (val: any) => {
      const {
        handleTimeLimit, auditTime, refuseTime, status,
      } = val;

      if (!handleTimeLimit) {
        return;
      }

      clearTimeInterval();

      // 预计完成时间
      const handleTimeLimitMoment = moment(handleTimeLimit, 'YYYY-MM-DD HH:mm:ss');
      // 核查上报时间点
      const auditTimeMoment = moment(auditTime, 'YYYY-MM-DD HH:mm:ss');
      // 拒绝接收时间点
      const refuseTimeMoment = moment(refuseTime, 'YYYY-MM-DD HH:mm:ss');

      // 待审核/已办结
      if (status === '4' || status === '5') {
        // 已处理
        if (auditTime) {
          if (handleTimeLimitMoment.isBefore(auditTimeMoment)) {
            // 已逾期
            countdown.finishInTime = true;
          }

          return;
        }

        // 未处理(拒绝接收) @todo moment() 改为拒绝时间
        if (handleTimeLimitMoment.isBefore(refuseTimeMoment)) {
          // 已逾期
          countdown.finishInTime = true;
        }

        return;
      }

      // 待接收/待处理
      if (status === '2' || status === '3') {
        // 未办结且已逾期
        if (handleTimeLimitMoment.isBefore(moment())) {
          countdown.finishInTime = true;

          return;
        }

        // 未办结且未逾期
        countdown.isFinish = true;

        let diff = handleTimeLimitMoment.valueOf() - moment().valueOf();

        const dealCountdown = (timeObj: any) => {
          countdown.days = Math.floor(timeObj.asDays()).toString().padStart(2, '0');
          countdown.hours = Math.floor(timeObj.hours()).toString().padStart(2, '0');
          countdown.minutes = Math.floor(timeObj.minutes()).toString().padStart(2, '0');
          countdown.seconds = Math.floor(timeObj.seconds()).toString().padStart(2, '0');
        };

        const time = moment.duration(diff);

        dealCountdown(time);

        timeInterval.value = setInterval(() => {
          diff -= 1000;
          if (diff > 0 || diff === 0) {
            const timeB = moment.duration(diff);

            dealCountdown(timeB);
          } else {
            countdown.isFinish = false;
          }
        }, 1000);
      }
    };

    watch(
      () => props.ticketDetail,
      (val) => {
        fileLists.value = [];
        textFileLists.value = [];
        textFileNameLists.value = [];
        if (val.picPath) {
          fileLists.value = val.picPath.split(',').map((cur: any) => `${ticketImageIp}${cur}`);
        }
        if (val.filePath) {
          textFileLists.value = val.filePath.split(',').map((cur: any) => `${ticketImageIp}${cur}`);
          textFileNameLists.value = val.fileName.split(',').map((cur: any) => cur);
        }

        if (Object.keys(val).length) {
          dealLimitTime(val);
        } else {
          clearTimeInterval();
        }
      }
    );

    const orderTypeList = ['placeholder',
      '自动',
      '手动',];

    return {
      fileLists,
      textFileLists,
      textFileNameLists,
      allTicketTypeList,
      orderTypeList,
      ticketStatus,
      countdown,
      handleTime,
      ticketTips,
      openFile,
      getPopupContainer,
      clearTimeInterval,
      dealLimitTime,
    };
  },
});
